module.exports = __webpack_public_path__ + "static/media/mobileScreenshot06.5f724a14.jpg";